










































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Vereniging extends Vue {
  public modal = {
    height: window.innerHeight > 700 ? 560 : window.innerHeight * 0.82,
    width: window.innerWidth > 900 ? 760 : window.innerWidth * 0.92
  };

  public beforeDestroy() {
    this.unlockPageScroll();
  }

  public lockPageScroll() {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  public unlockPageScroll() {
    document.documentElement.style.overflow = "auto";
    document.body.style.overflow = "auto";
  }
}
